import { phoneInputHandler } from '../../../../templates/main/phoneInputHandler';
import { waveEffect } from '../../../../templates/main/waveEffect';

const hiddenSids = ['PAGE_URL', 'UTM_SOURCE', 'UTM_MEDIUM', 'UTM_CAMPAIGN', 'UTM_TERM', 'UTM_CONTENT'];
const requiredSids = [
    'COMPANY_NAME',
    'CITY',
    'CONTACT_NAME',
    'PHONE',
    'ACTIVITY_TYPE',
    'EMAIL',
    'MONTHLY_SALES',
    'HAS_WAREHOUSE',
    'SUPPLIERS',
    'AGREEMENT',
];

export const Form = {
    data: () => ({
        fields: {},
        formData: {},
        formReady: false,
        formError: '',
        spinner: false,
        submited: false,
        countdown: 30,
        intervalId: null,
        errors: {},
    }),
    methods: {
        loadFields: function () {
            BX.ajax.runComponentAction('vv:forms', 'fields', {
                mode: 'class',
                data: {data: 'dealer'},
            }).then((response) => {
                if (response.data.status === 'error') {
                    this.formError = response.data.message || 'Форма временно недоступна.';
                    return;
                }

                this.fields = response.data.QUESTIONS || {};
                this.prepareFormData();
                this.formReady = true;
            }).catch(() => {
                this.formError = 'Форма временно недоступна. Пожалуйста, попробуйте позже.';
            });
        },
        prepareFormData: function () {
            Object.keys(this.fields).forEach((sid) => {
                const name = this.fieldName(sid);
                const answers = this.answers(sid);
                if (!name || !answers.length) {
                    return;
                }

                if (answers[0].FIELD_TYPE === 'checkbox' || answers[0].FIELD_TYPE === 'multiselect') {
                    this.formData[name] = [];
                } else {
                    this.formData[name] = '';
                }
            });

            this.setHiddenValues();
        },
        setHiddenValues: function () {
            hiddenSids.forEach((sid) => {
                const name = this.fieldName(sid);
                if (this.fields[sid] && name) {
                    this.formData[name] = this.hiddenValue(sid);
                }
            });
        },
        hiddenValue: function (sid) {
            const params = new URLSearchParams(window.location.search);
            const map = {
                PAGE_URL: window.location.href,
                UTM_SOURCE: params.get('utm_source') || '',
                UTM_MEDIUM: params.get('utm_medium') || '',
                UTM_CAMPAIGN: params.get('utm_campaign') || '',
                UTM_TERM: params.get('utm_term') || '',
                UTM_CONTENT: params.get('utm_content') || '',
            };

            return map[sid] || '';
        },
        fieldName: function (sid) {
            const answers = this.answers(sid);
            return answers.length ? answers[0].HTML_NAME.replace(/\[\]$/, '') : sid;
        },
        answers: function (sid) {
            return this.fields[sid] && this.fields[sid].ANSWERS ? this.fields[sid].ANSWERS : [];
        },
        agreementValue: function () {
            const answers = this.answers('AGREEMENT');
            return answers.length ? String(answers[0].ID) : '';
        },
        inputClass: function (sid) {
            return [
                'form__field',
                {
                    'form__field--disabled': (this.spinner || this.submited || !this.formReady),
                    'form__field--error': Boolean(this.errors[sid]),
                },
            ];
        },
        responseError: function (payload) {
            payload = payload || {};
            const errors = Array.isArray(payload.errors) ? payload.errors.filter(Boolean) : [];
            return payload.message || errors.join(' ') || 'Не удалось отправить заявку.';
        },
        validate: function () {
            const errors = {};

            requiredSids.forEach((sid) => {
                const name = this.fieldName(sid);
                const value = this.formData[name];
                const emptyArray = Array.isArray(value) && value.length === 0;
                if (value === undefined || value === '' || emptyArray) {
                    errors[sid] = 'Поле обязательно к заполнению';
                }
            });

            const phone = this.formData[this.fieldName('PHONE')] || '';
            if (phone.replace(/\D/g, '').length < 9) {
                errors.PHONE = 'Укажите корректный телефон';
            }

            const email = this.formData[this.fieldName('EMAIL')] || '';
            if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                errors.EMAIL = 'Укажите корректный email';
            }

            this.errors = errors;
            return Object.keys(errors).length === 0;
        },
        send: function (e) {
            e.preventDefault();

            if (!this.validate()) {
                return;
            }

            this.setHiddenValues();
            this.spinner = true;
            this.formError = '';

            BX.ajax.runComponentAction('vv:forms', 'save', {
                mode: 'class',
                data: {data: {fields: this.formData, form_id: 'dealer'}},
            }).then((response) => {
                this.spinner = false;
                if (response.data.status === 'success') {
                    const now = new Date().getTime();
                    localStorage.setItem('lastFormDealerSubmitTime', now);
                    this.submited = true;
                    this.startCountdown();
                } else {
                    this.formError = this.responseError(response.data);
                }
            }).catch(() => {
                this.spinner = false;
                this.formError = 'Не удалось отправить заявку. Пожалуйста, попробуйте позже.';
            });
        },
        startCountdown: function () {
            this.intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.clearForm();
                }
            }, 1000);
        },
        clearForm: function () {
            localStorage.removeItem('lastFormDealerSubmitTime');
            clearInterval(this.intervalId);
            Object.keys(this.formData).forEach((name) => {
                this.formData[name] = Array.isArray(this.formData[name]) ? [] : '';
            });
            this.setHiddenValues();
            this.errors = {};
            this.submited = false;
            this.countdown = 30;
        },
    },
    mounted () {
        this.loadFields();
        phoneInputHandler();
        waveEffect();

        const lastSubmitTime = localStorage.getItem('lastFormDealerSubmitTime');
        if (lastSubmitTime) {
            const now = new Date().getTime();
            const diff = now - lastSubmitTime;
            const remainingTime = 30 - Math.floor(diff / 1000);
            if (remainingTime > 0) {
                this.countdown = remainingTime;
                this.submited = true;
                this.startCountdown();
            }
        }
    },
    template: `<form action="" class="dealer-form form" @submit="send">
                    <div v-if="formError" class="dealer-form__notice dealer-form__notice--error">{{ formError }}</div>
                    <div v-if="!formReady && !formError" class="dealer-form__notice">Загрузка формы...</div>
                    <div class="dealer-form__grid">
                        <label class="dealer-form__group">
                            <span>Название компании <b>*</b></span>
                            <input type="text" :name="fieldName('COMPANY_NAME')" :class="inputClass('COMPANY_NAME')" v-model="formData[fieldName('COMPANY_NAME')]" placeholder="ООО «Компания»">
                            <em v-if="errors.COMPANY_NAME">{{ errors.COMPANY_NAME }}</em>
                        </label>
                        <label class="dealer-form__group">
                            <span>Город / населенный пункт <b>*</b></span>
                            <input type="text" :name="fieldName('CITY')" :class="inputClass('CITY')" v-model="formData[fieldName('CITY')]" placeholder="Казань">
                            <em v-if="errors.CITY">{{ errors.CITY }}</em>
                        </label>
                        <label class="dealer-form__group">
                            <span>ФИО контактного лица <b>*</b></span>
                            <input type="text" :name="fieldName('CONTACT_NAME')" :class="inputClass('CONTACT_NAME')" v-model="formData[fieldName('CONTACT_NAME')]" placeholder="Иванов Иван">
                            <em v-if="errors.CONTACT_NAME">{{ errors.CONTACT_NAME }}</em>
                        </label>
                        <label class="dealer-form__group">
                            <span>Контактный телефон <b>*</b></span>
                            <input type="text" :name="fieldName('PHONE')" :class="['js-phone'].concat(inputClass('PHONE'))" v-model="formData[fieldName('PHONE')]" placeholder="+7 (___) ___-__-__">
                            <em v-if="errors.PHONE">{{ errors.PHONE }}</em>
                        </label>
                        <label class="dealer-form__group">
                            <span>Email <b>*</b></span>
                            <input type="email" :name="fieldName('EMAIL')" :class="inputClass('EMAIL')" v-model="formData[fieldName('EMAIL')]" placeholder="mail@example.ru">
                            <em v-if="errors.EMAIL">{{ errors.EMAIL }}</em>
                        </label>
                        <label class="dealer-form__group">
                            <span>Приблизительный ежемесячный объем продаж запасных частей <b>*</b></span>
                            <input type="text" :name="fieldName('MONTHLY_SALES')" :class="inputClass('MONTHLY_SALES')" v-model="formData[fieldName('MONTHLY_SALES')]" placeholder="Например, 1 500 000 руб.">
                            <em v-if="errors.MONTHLY_SALES">{{ errors.MONTHLY_SALES }}</em>
                        </label>
                    </div>
                    <div class="dealer-form__choices">
                        <fieldset>
                            <legend>Вид деятельности <b>*</b></legend>
                            <label v-for="answer in answers('ACTIVITY_TYPE')" :key="answer.ID" class="dealer-form__choice">
                                <input type="radio" :name="fieldName('ACTIVITY_TYPE')" :value="String(answer.ID)" v-model="formData[fieldName('ACTIVITY_TYPE')]" :disabled="spinner || submited || !formReady">
                                <span>{{ answer.MESSAGE }}</span>
                            </label>
                            <em v-if="errors.ACTIVITY_TYPE">{{ errors.ACTIVITY_TYPE }}</em>
                        </fieldset>
                        <fieldset>
                            <legend>Наличие склада <b>*</b></legend>
                            <label v-for="answer in answers('HAS_WAREHOUSE')" :key="answer.ID" class="dealer-form__choice">
                                <input type="radio" :name="fieldName('HAS_WAREHOUSE')" :value="String(answer.ID)" v-model="formData[fieldName('HAS_WAREHOUSE')]" :disabled="spinner || submited || !formReady">
                                <span>{{ answer.MESSAGE }}</span>
                            </label>
                            <em v-if="errors.HAS_WAREHOUSE">{{ errors.HAS_WAREHOUSE }}</em>
                        </fieldset>
                    </div>
                    <label class="dealer-form__group dealer-form__group--wide">
                        <span>С каким поставщиком работаете / работали <b>*</b></span>
                        <textarea :name="fieldName('SUPPLIERS')" :class="inputClass('SUPPLIERS')" v-model="formData[fieldName('SUPPLIERS')]" rows="4" placeholder="Укажите текущих или предыдущих поставщиков"></textarea>
                        <em v-if="errors.SUPPLIERS">{{ errors.SUPPLIERS }}</em>
                    </label>
                    <label class="dealer-form__agree">
                        <input type="checkbox" :name="fieldName('AGREEMENT')" :value="agreementValue()" v-model="formData[fieldName('AGREEMENT')]" :disabled="spinner || submited || !formReady">
                        <span>Я принимаю условия <a href="/conf/" target="_blank">политики конфиденциальности</a></span>
                    </label>
                    <em v-if="errors.AGREEMENT" class="dealer-form__agree-error">{{ errors.AGREEMENT }}</em>
                    <div class="dealer-form__actions">
                        <div v-if="submited" class="form__submited"><span>Отправлено</span></div>
                        <div class="form__sending" v-if="spinner"><div class="form__spinner"><div></div><div></div><div></div><div></div></div></div>
                        <button v-if="!spinner && !submited" type="submit" class="form__submit btn" :disabled="!formReady">Отправить заявку</button>
                        <div v-if="submited" class="form__disabled-time">Форму можно повторно отправить через {{ countdown }} сек.</div>
                    </div>
                    <p class="form__conf">Нажимая кнопку "Отправить заявку", вы соглашаетесь с обработкой персональных данных.</p>
                </form>`
};
